import { Lens } from 'monocle-ts';

import { rootDomain } from '@stores/root';

import { applyLensPayload } from '@utils/lens';

export type DialogsState = {
    isOpenFeedback: boolean;
    isOpenFeedbackSuccess: boolean;
    isOpenLogin: boolean;
    isOpenDevelop: boolean;
    isOpenDocuments: boolean;
    isOpenAddAddress: boolean;
};
const dialogsDomain = rootDomain.createDomain();

// --- Events ---
export const setIsOpenFeedback = dialogsDomain.createEvent<DialogsState['isOpenFeedback']>();
export const setIsOpenFeedbackSuccess =
    dialogsDomain.createEvent<DialogsState['isOpenFeedbackSuccess']>();
export const setIsOpenLogin = dialogsDomain.createEvent<DialogsState['isOpenLogin']>();
export const setIsOpenDevelop = dialogsDomain.createEvent<DialogsState['isOpenDevelop']>();
export const setIsOpenDocuments = dialogsDomain.createEvent<DialogsState['isOpenDocuments']>();
export const setIsOpenAddAddress = dialogsDomain.createEvent<DialogsState['isOpenAddAddress']>();

// --- Lenses ---
export const isOpenFeedbackLens = Lens.fromProp<DialogsState>()('isOpenFeedback');
export const isOpenFeedbackSuccessLens = Lens.fromProp<DialogsState>()('isOpenFeedbackSuccess');
export const isOpenLoginLens = Lens.fromProp<DialogsState>()('isOpenLogin');
export const isOpenDevelopLens = Lens.fromProp<DialogsState>()('isOpenDevelop');
export const isOpenDocumentsLens = Lens.fromProp<DialogsState>()('isOpenDocuments');
export const isOpenAddAddressLens = Lens.fromProp<DialogsState>()('isOpenAddAddress');

const dialogsInitialState: DialogsState = {
    isOpenFeedback: false,
    isOpenFeedbackSuccess: false,
    isOpenLogin: false,
    isOpenDevelop: false,
    isOpenDocuments: false,
    isOpenAddAddress: false,
};

export const $dialogs = dialogsDomain
    .createStore<DialogsState>(dialogsInitialState, { name: 'dialogs' })
    .on(setIsOpenFeedback, applyLensPayload(isOpenFeedbackLens))
    .on(setIsOpenFeedbackSuccess, applyLensPayload(isOpenFeedbackSuccessLens))
    .on(setIsOpenLogin, applyLensPayload(isOpenLoginLens))
    .on(setIsOpenDevelop, applyLensPayload(isOpenDevelopLens))
    .on(setIsOpenAddAddress, applyLensPayload(isOpenAddAddressLens))
    .on(setIsOpenDocuments, applyLensPayload(isOpenDocumentsLens));
